// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-789d5ae6]{width:100%;height:100vh}.container .content[data-v-789d5ae6]{height:calc(100% - 138px);box-sizing:border-box;overflow-y:auto;padding:0 60px}.container .content .title[data-v-789d5ae6]{margin:30px 0;color:#000;font-weight:700;font-size:20px;text-align:center;position:relative}.container .content .title .userPotrait[data-v-789d5ae6]{position:absolute;right:0;top:0;z-index:5}", ""]);
// Exports
module.exports = exports;
